module.exports = __webpack_public_path__ + "img/Group1.5e8e0d57.png";